import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6797c54f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-container" }

import { ref, computed } from "vue";

import BreadCrumbs from "@/shared/menu/BreadCrumbs.vue";
import Button from "primevue/button";
import TopPanel from "@/widgets/sidebars/TopPanel.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopSegmentPanel',
  props: {
    isCreateButtonEnabled: { type: Boolean },
    isLoading: { type: Boolean },
    isSegmentSetted: { type: Boolean }
  },
  emits: ["createSegment"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const items = computed(() => [
  { label: "Сегмент", route: "listSegments" },
  { label: props.isSegmentSetted ? "Просмотр сегмента" : "Создание сегмента" },
]);

const createSegment = () => {
  emit("createSegment");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TopPanel, null, {
    default: _withCtx(() => [
      _createVNode(BreadCrumbs, {
        items: items.value,
        class: "s-bread"
      }, null, 8, ["items"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Button), {
          label: "Сохранить сегмент",
          class: "segment-save-button m-l-16 m-r-16",
          disabled: !_ctx.isCreateButtonEnabled,
          onClick: createSegment,
          loading: _ctx.isLoading
        }, null, 8, ["disabled", "loading"])
      ])
    ]),
    _: 1
  }))
}
}

})